import { useState, useEffect } from 'react';
import {Space, Row, Button, Table, Divider, message, PageHeader } from 'antd';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';
import {DeleteOutlined} from '@ant-design/icons';
import LaborAdd from './LaborAdd';
import LaborUpdate from './LaborUpdate';
import axios from 'axios';
import moment from 'moment';


const LaborComponent = ()=>{

    const [laborData, setLaborData] = useState()
    const [employeeData, setEmployeeData] = useState()
    const [vehicleData, setVehicleData] = useState()


    const fetchLabor = ()=>{
        let getLabor = `${FetchVariable.Heroku}/labor/`
        axios.get(getLabor)
            .then((res)=>{
                let data =res.data
                setLaborData(data)
            })
        };

    useEffect(()=>{
        let EmployeeURL = `${FetchVariable.Heroku}/employee/`
        axios.get(EmployeeURL)
        .then((res)=>{
            let data=res.data
            setEmployeeData(data)
        })
    },[]);

    useEffect(()=>{
        let apiURL = `${FetchVariable.Heroku}/vehicle/`
        axios.get(apiURL)
        .then((res)=>{
            let data=res.data
            setVehicleData(data)
        })
    },[]);

    function deleteLabor(deleteID){
            let deleteLabor = `${FetchVariable.Heroku}/labor/`+deleteID
            axios.delete(deleteLabor)
                .then(() => {
                fetchLabor()
                message.error('The Labor is deleted')
                })
    };

    const addLabor = (addLaborData)=>{
        addLaborData.LaborDate = moment(addLaborData.LaborDate).format("YYYY-MM-DD")
            let apiURL = `${FetchVariable.Heroku}/labor/`
            axios.post(apiURL, addLaborData)
            .then(() => {
                fetchLabor()
            })
              .catch(err=>{console.log(err)})
    };

    const updateLabor = (updateLabor)=>{
        updateLabor.LaborDate = moment(updateLabor.LaborDate).format("YYYY-MM-DD")
            let apiURL = `${FetchVariable.Heroku}/labor/`
            axios.put(apiURL, updateLabor)
            .then(() => {
                fetchLabor()
            })
            .catch(err=>{console.log(err)})
    };

    let employeeFilter = []
    employeeData?.forEach((e)=>{
            employeeFilter.push(
                {
                    text:e.EmployeeName,
                    value:e.EmployeeName
                }
            )
    });

    let vehicleFilter = []
    vehicleData?.forEach((e)=>{
            vehicleFilter.push(
                {
                    text:e.VehicleID,
                    value:e.VehicleID
                }
            )
    });

    useEffect(() => {
        fetchLabor();
    }, [])

    
        const LaborColums = [
        {
            title: 'Labor ID',
            dataIndex: 'LaborID',
            key: 'LaborID',
            sorter: (a, b) => a.LaborID - b.LaborID,
            sortDirections: ['descend','ascend'],
            defaultSortOrder: 'descend',
        },
        {
            title: 'Vehicle ID',
            dataIndex: 'VehicleID',
            key: 'VehicleID',
            filters:vehicleFilter,
            filterSearch: true,
            onFilter: (value, record) => record.VehicleID === value,
        },
        {
            title: 'Employee Name',
            dataIndex: 'EmployeeName',
            key: 'EmployeeName',
            filters:employeeFilter,
            filterSearch: true,
            onFilter: (value, record) => record.EmployeeName.indexOf(value) === 0,
        },
        {
            title: 'Labor Date',
            dataIndex: 'LaborDate',
            key: 'LaborDate',
        },
        {
            title: 'Labor Hours',
            dataIndex: 'LaborHours',
            key: 'LaborHours',
        },
        {
            title: 'Action',
            key: 'action',
            render: (record) => (
              <Space size="middle">
                <LaborUpdate record={record} updateLabor={updateLabor}/>
                <Button onClick={()=> deleteLabor(record.LaborID)} type="primary" danger icon={<DeleteOutlined />}></Button>
              </Space>
            ),
          },
    ]

    return(
        <>
            <PageHeader
            className="site-page-header"
            title="Labor Management"
            extra={[ 
                <LaborAdd addLabor={addLabor}/>,
            ]}
            >
            </PageHeader>

            <Divider />
            <Row>
                <Table columns={LaborColums} dataSource={laborData} rowKey={(record)=>record.LaborID} scroll={{x:1500, y:1000}}/>
            </Row>
        </>
    )
}

export default LaborComponent